import React, { useEffect, useMemo, useRef, useState } from "react";
import { Section } from "./Section";

const SPECS = [
  {
    id: "spec-network",
    label: "Network Solutions",
    value: "SD-WAN, VPN, Firewall, Load Balancing",
  },
  {
    id: "spec-backup",
    label: "Backup & DR",
    value: "Veeam, Acronis, DR Planning",
  },
  {
    id: "spec-devops",
    label: "DevOps & CI/CD",
    value: "Jenkins, GitLab, Docker, Kubernetes",
  },
  {
    id: "spec-db",
    label: "Database Management",
    value: "MySQL, PostgreSQL, MongoDB, SQL Server",
  },
  {
    id: "spec-support",
    label: "Support Availability",
    value: "24/7/365, 15-min response",
  },
  {
    id: "spec-certs",
    label: "Certifications",
    value: "Microsoft, AWS Partner, Cisco Partner",
  },
];

const OBSERVER_THRESHOLD = 0.15;

export const Specs = () => {
  const rowRefs = useRef([]);
  const [visible, setVisible] = useState(() => new Set());

  const observerOptions = useMemo(
    () => ({ threshold: OBSERVER_THRESHOLD }),
    []
  );

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      setVisible((prev) => {
        const next = new Set(prev);
        let changed = false;
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const idx = entry.target.dataset.idx;
            if (idx && !next.has(idx)) {
              next.add(idx);
              changed = true;
              observer.unobserve(entry.target);
            }
          }
        });
        return changed ? next : prev;
      });
    }, observerOptions);

    rowRefs.current.forEach((el) => el && observer.observe(el));
    return () => observer.disconnect();
  }, [observerOptions]);

  return (
    <Section id="specs" className="bg-zinc-950 py-24 lg:py-32 border-t border-white/5">
      <div className="reveal-up max-w-2xl">
        <div className="text-xs uppercase tracking-[0.22em] text-[#FF4500] font-semibold">
          Capabilities
        </div>
        <h2
          className="mt-4 text-4xl sm:text-5xl font-black tracking-[-0.02em] text-white"
          style={{ fontFamily: "Outfit, sans-serif" }}
        >
          The stack we run, in plain spec.
        </h2>
      </div>

      <div className="mt-14 grid grid-cols-1 xl:grid-cols-2 gap-4 xl:gap-6">
        {SPECS.map((row, idx) => {
          const isVisible = visible.has(String(idx));
          return (
            <div
              key={row.id}
              ref={(el) => (rowRefs.current[idx] = el)}
              data-idx={String(idx)}
              data-testid={row.id}
              className={`specs-inview grid grid-cols-1 sm:grid-cols-[minmax(0,220px)_1fr] gap-2 sm:gap-6 xl:gap-8 px-6 md:px-8 py-6 md:py-7 border border-white/10 bg-white/[0.02] rounded-2xl transition-all duration-700 ease-out ${
                isVisible
                  ? "opacity-100 translate-y-0"
                  : "opacity-0 translate-y-3"
              }`}
            >
              <div className="text-xs uppercase tracking-[0.18em] font-semibold text-zinc-500">
                {row.label}
              </div>
              <div
                className="text-base md:text-lg font-semibold text-white"
                style={{ fontFamily: "Outfit, sans-serif" }}
              >
                {row.value}
              </div>
            </div>
          );
        })}
      </div>
    </Section>
  );
};

export default Specs;
